
import { Vue, Component, Prop } from "vue-property-decorator";
import { AmCard, AmCardBody } from "@afe/amui/src/components/Card";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmButton } from "@afe/amui/src/components/Button";
import { AmSpacing } from "@afe/amui/src/components/Spacing";
import { FormField, Preloader, FormSubmit } from "../components";
import { DEMO_FORM_STEPS, mactraderJwtSubmit } from "@/forms/service";

@Component({
  components: {
    AmCard,
    AmTypography,
    AmCardBody,
    FormField,
    FormSubmit,
    AmSpacing,
    AmButton,
    Preloader
  }
})
export default class extends Vue {
  @Prop(Object) readonly config!: any;
  @Prop(String) readonly token!: string;
  @Prop(Number) readonly emailType!: number;
  @Prop(String) readonly policyText!: string;
  @Prop(String) readonly requestType!: string;

  loading = false;

  onSubmit() {
    this.loading = true;

    const formData = {
      jwt: this.token,
      emailType: this.emailType,
      trading_panel_request_type: this.requestType
    };

    mactraderJwtSubmit(formData)
      .then(({ next }) => {
        if (next === DEMO_FORM_STEPS.THANK_YOU_STEP) {
          this.$emit("successAccess");
        }
      })
      .catch(() => {
        this.loading = false;
        this.$emit("errorAccess");
      });
  }
}
